import script from "./SimpleSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleSlider.vue?vue&type=script&setup=true&lang=js"

import "./SimpleSlider.vue?vue&type=style&index=0&id=7c6f5cb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6f5cb3"]])

export default __exports__